import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const customerCreate = (data: unknown) => {
  return axios({
    method: "POST",
    url: "/customers",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getCustomers = (params: any, moduleName?: string) => {
  return axios({
    method: "GET",
    url: "/customers",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};

export const massDeleteCustomers = (data: { customerIds: number[] }) => {
  const url = "customers/massDelete";
  return axios({
    method: "Delete",
    url: url,
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const massUpdateCustomers = (data: {
  customerIds: number[];
  fieldToUpdate: any;
}) => {
  const url = "customers/massUpdate";
  return axios({
    method: "PUT",
    url: url,
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getCustomerDetails = (customerId: any) => {
  return axios({
    method: "GET",
    url: `/customers/${customerId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateCustomerDetails = (customerId: any, data: any) => {
  return axios({
    method: "PUT",
    url: `/customers/${customerId}`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getUserDetails = (params?: any, moduleName?: string) => {
  return axios({
    method: "GET",
    url: `/users`,
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const uploadFile = (formData: FormData) => {
  return axios({
    method: "POST",
    url: "/customers/import",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addCustomerAttachment = (customerId: number, data: any) => {
  return axios({
    method: "POST",
    url: `/customers/${customerId}/attachment`,
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAttachments = (customerId: number) => {
  return axios({
    method: "GET",
    url: `/customers/${customerId}/attachments`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addCustomerLinkAttachment = (customerId: number, data: any) => {
  return axios({
    method: "PUT",
    url: `/customers/${customerId}/attachment-link`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteCustomerAttachment = (customerId: number, attachmentId: number) => {
  return axios({
    method: "Delete",
    url: `/customers/${customerId}/attachments/${attachmentId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const campainAssignToCustomers = (data: {
  actionScope: "multiCustomer_singleCampaign" | "singleCustomer_multiCampaign";
  customerIds: number[];
  campaignId: number;
  customerStatusInCampaign: string;
}, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: `/customers/addToCampaigns`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const multiplecampainsAssignToCustomers = (data: {
  actionScope: "multiCustomer_singleCampaign" | "singleCustomer_multiCampaign";
  campaignIds: number[];
  customerId: number;
  customerStatusInCampaign: string;
}, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: `/customers/addToCampaigns`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const deleteCampaignAssign = (
  customerId: number,
  campaignCustomerAssociationId: number,
  moduleName?: string,
  resourceType: "Lead" | "Customer" = "Customer"
) => {
  const url = `/customers/${customerId}/campaign-associations/${campaignCustomerAssociationId}`;
  return axios.delete(url, {
    params: { resourceType },
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const editCampaignStatus = (status: string, resourceIds: number[], resourceType: "Lead" | "Customer", moduleName?: string) => {
  const url = `/customers/updateMemberStatusInCampaign`;
  return axios.put(
    url,
    {
      status,
      resourceIds,
      resourceType,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-source-module": moduleName,
      },
    }
  );
};
export const exportCustomers = (format: string, customerIds: number[]) => {
  return axios({
    method: "POST",
    url: `/customers/export?format=${format}`,
    data: { customerIds },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};
export const leadApprove = (data: unknown) => {
  return axios({
    method: "POST",
    url: "/leads/approve",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const leadLinkActivityLog = (id: any, data: unknown) => {
  return axios({
    method: "POST",
    url: `/leads/${id}/initiate`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const mergeExactCustomerDetails = (data: any) => {
  return axios({
    method: "PUT",
    url: `/leads/merge-duplicates`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getCustomerLeads = (customerId: number) => {
  return axios({
    method: "GET",
    url: `/customers/${customerId}/leads`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export const addCustomerDocument = (customerId: number, data: any) => {
  return axios({
    method: "POST",
    url: `/customers/${customerId}/documents`,
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};
export const editCustomerDocument = (customerId: number,documentId:number ,data: any) => {
  return axios({
    method: "PUT",
    url: `/customers/${customerId}/documents/${documentId}`,
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};
export const deleteDocument = (customerId: number,documentId:number) => {
  const token = getAuthToken();
  return axios({
    method: "Delete",
    url: `/customers/${customerId}/documents/${documentId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
// export const assignCampaignToMultipleCustomers = (
//   data: {
//     customerId: number;
//     campaignIds: number[];
//     customerStatusInCampaign?: string;
//   },
//   moduleName?: string
// ) => {
//   const token = getAuthToken();
//   return axios({
//     method: "POST",
//     url: `/customers/addToCampaigns`,
//     data,
//     headers: {
//       Authorization: `Bearer ${token}`,
//       "x-source-module": moduleName || "",
//     },
//   });
// };

export const customerLinkActivityLog = (id: any, data: unknown) => {
  return axios({
    method: "POST",
    url: `/customers/${id}/initiate`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const sendCustomerSMSAndActivityLog = (id: any, data: unknown) => {
  return axios({
    method: "POST",
    url: `/customers/${id}/sendSms`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};